import { compact } from "lodash";
import { LoadingDots } from "PFComponents/loading_dots";
import { Typography } from "PFComponents/typography";
import React from "react";
import { useTranslation } from "react-i18next";

import { useMarketplaceContext } from "../../../contexts/marketplace_context";
import { Tile } from "../../components";
import css from "./my_preferences.module.scss";
import { useFormattedPreferences } from "./use_formatted_preferences";

export const MyPreferences = (): JSX.Element => {
  const { t } = useTranslation("marketplace", { keyPrefix: "dashboard.myPreferences" });
  const { formattedWorkTypes, formattedProjectLength, formattedSkills, isLoading } =
    useFormattedPreferences();
  const { modal } = useMarketplaceContext();

  const onEditPreferences = () => {
    modal.setType("editPreferences");
  };

  const formattedRows = compact([formattedWorkTypes, formattedProjectLength, formattedSkills]);

  return (
    <Tile title={t("title")} iconName="admin" label={t("editPreferences")} onClick={onEditPreferences}>
      {!isLoading ? (
        <div className={css.preferences}>
          {formattedRows.map((formattedRow, index) => (
            <Typography key={index} variant="bodyRegular" noMargin>
              {formattedRow}
            </Typography>
          ))}

          {formattedRows.length === 0 && (
            <Typography variant="bodyRegular" noMargin>
              {t("noPreferences")}
            </Typography>
          )}
        </div>
      ) : (
        <div className={css.loaderWrapper}>
          <LoadingDots circlesEnabled circleSize="xs" />
        </div>
      )}
    </Tile>
  );
};
